import React from 'react'
import { Form } from '@deere/ux.uxframe-react';
import { getTranslation } from '../utils/utils';

export default function RadioGroup({ radioLabels, updateAnswer, question, defaultValue, section, checkedProprietary }) {
    return (
        <>
            {
                radioLabels.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1).map((radio) =>
                    <Form.Check
                        required={!checkedProprietary}
                        type="radio"
                        inline
                        id={radio.id}
                        key={radio.id}
                        label={getTranslation(radio, 'text')}
                        name={`${section}-${question.id}`}
                        value={radio.value}
                        onChange={(e) => updateAnswer(e, question.id)}
                        checked={defaultValue === radio.value} />
                )
            }
        </>
    )
}